export default __webpack_public_path__ + "media/images/icons/chevron-down-solid-a4f409dd60b89c8a341c1d9830ae0043.svg";